import axios from "axios";
import { gangtokInstance as http } from "./http-common";

const token = JSON.parse(localStorage.getItem("token"));

const getRevenueCollection = (data) => {
  return http.post("CentralDashboard/GetRevenueCollection", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const fetchFuelConsume = (data) => {
  return http.post("CentralFuelConsume/CentralDash_GetFuelConsume", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const depoDashFuelConsume = (data) => {
  return http.post("DepoDashFuelConsume", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getVehicleStsCount = (data) => {
  return http.post("VehicleStsCount/CentralDash_VehicleStsCount", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getTodaysFuelStatus = () => {
  return http.get("GetTodaysFuelStatus", {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getVehicleStatus = (data) => {
  return http.post("VehicleStatus/GetVehicleStatus", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getDutyReportCentral = (data) => {
  return http.post("DutyReport/CentDash_DutyReportCnt", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const newRevenueGenerate = (type) => {
  return http.post(
    `NewRevenueCollection/GetNewRevenueCollection?type=${type}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

const getObtsCollection = (type) => {
  return http.post(`CentralOBTS/GetNewObtsCollectionCentral?type=${type}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getVehicleTypes = () => {
  return http.get(`VehicleStsCount/getVechtypes`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getDaywiseRevenue = (data) => {
  return http.post(`RevenueDaywise/GetRevenueCollectionDaywise?date=${data}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// 20-04-2026 by Khyati Chauhan, api - Bhavya Patel
const getLatLongForMap = () => {
  return axios.get(`http://sntitsapi.fdca.co.in/api/getLastTrackingData`);
};

// 22-04-2026 Khyati Chauhan, api - Satyajit Das
const getDutyWithFuel = (data) => {
  return http.post(`obtsCount/GetDutyDetilsWithFuel`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const CentralDashboardService = {
  getRevenueCollection,
  fetchFuelConsume,
  depoDashFuelConsume,
  getVehicleStsCount,
  getTodaysFuelStatus,
  getVehicleStatus,
  getDutyReportCentral,
  newRevenueGenerate,
  getObtsCollection,
  getVehicleTypes,
  getDaywiseRevenue,
  getLatLongForMap,
  getDutyWithFuel,
};

export default CentralDashboardService;
